import {createApp} from 'vue';
import App from './App.vue';
import store from './store';
import displayModule from './components/display-conditions';
import rowCategoriesModule from './components/row-categories';
import rowsModule from './components/rows';
import AuthSupport from './functions/authSupport.js';
import ServiceClient from './functions/serviceClient.js';
import messageService from './functions/messageService.js';
import messageHandler from './functions/messageHandler.js';
import originValidator from './functions/originValidator.js';

import i18n from './i18n';

import {library} from '@fortawesome/fontawesome-svg-core';
import {faDatabase} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import VueSelect from 'vue-select';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import pkg from '../package.json';
import Antd from 'ant-design-vue';
import * as Icons from '@ant-design/icons-vue';
import 'ant-design-vue/dist/reset.css';

const version = pkg.version;
library.add(faDatabase);

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
  appVersion: version,
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE,
  enabledReleaseStages: ['production']
});

const app = createApp(App);

const bugsnagVue = Bugsnag.getPlugin('vue');
bugsnagVue.installVueErrorHandler(app);

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('v-select', VueSelect);
Object.entries(Icons).forEach(([key, component]) => {
  app.component(key, component);
});

app.use(Antd);

const searchParams = new URL(document.location.href).searchParams;
const customer = searchParams.get('customer');
const newsletter = searchParams.get('newsletter') || undefined;
const userDbId = parseInt(searchParams.get('userDbId'), 10) || undefined;
const hideUseButton = searchParams.get('hideUseButton') || 'false';
const allowedOrigin = originValidator.check();
const msgService = messageService(window.parent, allowedOrigin);

const authSupport = AuthSupport(msgService);
const serviceClient = ServiceClient(process.env.VUE_APP_ED_API, msgService);
const state = store(authSupport, serviceClient, msgService);

state.commit('setCustomer', customer);
state.commit('setNewsletter', newsletter);
state.commit('setUserDb', userDbId);
state.commit('setHideUseButton', hideUseButton);
state.dispatch('checkUserAccess');
state.registerModule('displayModule', displayModule(serviceClient));
state.registerModule('rowCategoriesModule', rowCategoriesModule(serviceClient));
state.registerModule('rowsModule', rowsModule(serviceClient));

window.addEventListener('message', function (event) {
  if (originValidator.isAllowed(event.origin)) {
    messageHandler(state, msgService).handle(event.data);
  }
});

app.use(state);
app.use(i18n);

app.mount('#app');
